/** Asset category (multifamily, etc.) — distinct from investment "property class" badge. */
export const DEAL_ASSET_TYPE_OPTIONS = [
  'Multifamily',
  'Mixed-use',
  'Office',
  'Retail',
  'Industrial',
  'Hospitality',
  'Land',
  'Other',
] as const;

export const DEAL_PROPERTY_CLASS_OPTIONS = [
  'Class A',
  'Class B',
  'Class C',
  'Class D',
] as const;

export const DEAL_STRATEGY_OPTIONS = [
  'Core',
  'Core Plus',
  'Value-Add',
  'Opportunistic',
  'Cash Flow',
  'Appreciation',
  'Tax Advantage',
  'Income-Producing',
  'Institutional Grade',
  'Redevelopment',
  'Repositioning',
] as const;
